import { render } from "./Main.vue?vue&type=template&id=2ea6eabc"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=2ea6eabc&lang=less"
script.render = render

export default script